import Parse from 'parse'

export const SERVER_INVITE_TOKEN_PREFIX = 'inv_'

export type RoomInviteLinkPreset = 'once' | '1h' | '6h' | '12h' | '24h'
export type RoomInviteAudience = 'same_company' | 'open'

export interface CreateRoomInviteParams {
  roomId: string | null
  customRoomId?: string | null
  companyId?: string | null
  linkPreset: RoomInviteLinkPreset
  audience: RoomInviteAudience
  defaultJoinNear: boolean
}

export interface CreateRoomInviteResult {
  success: boolean
  token: string
  joinPath: string
}

export async function createRoomInviteCloud(params: CreateRoomInviteParams): Promise<CreateRoomInviteResult> {
  const res = (await Parse.Cloud.run('createRoomInvite', {
    roomId: params.roomId || null,
    customRoomId: params.customRoomId ?? null,
    companyId: params.companyId ?? null,
    linkPreset: params.linkPreset,
    audience: params.audience,
    defaultJoinNear: params.defaultJoinNear,
  })) as CreateRoomInviteResult
  return res
}

export interface PreviewRoomInviteResult {
  valid: boolean
  errorCode?: string
  roomId?: string | null
  customRoomId?: string | null
  companyId?: string | null
  sharerUserId?: string | null
  defaultJoinNear?: boolean
  audience?: RoomInviteAudience | string
  linkKind?: string
  expiresAt?: string | null
  consumed?: boolean
  allowedForCurrentUser?: boolean
  denyReason?: string | null
}

export async function previewRoomInviteCloud(token: string): Promise<PreviewRoomInviteResult> {
  return (await Parse.Cloud.run('previewRoomInvite', { token })) as PreviewRoomInviteResult
}

export function isServerInviteToken(token: string): boolean {
  return typeof token === 'string' && token.startsWith(SERVER_INVITE_TOKEN_PREFIX)
}
